import { Directive, Input, ViewContainerRef, OnInit } from '@angular/core';
import { ShapeComponent } from '../components/shape/shape.component';

@Directive({
    selector: '[dynamic-svg]'
})
export class DynamicSvgDirective {

    @Input() component: ShapeComponent;

    constructor(private viewContainerRef: ViewContainerRef) {
    }

    ngOnInit() {
        //console.log('DynamicSvgDirective ngOnInit() - component : ', this.component);

        let shapeComponent: ShapeComponent = this.component;
        this.viewContainerRef.createEmbeddedView(shapeComponent.shapeTemplate);
    }

    ngOnDestroy() {
        console.log('DynamicSvgDirective ngOnDestroy()');
        this.viewContainerRef.clear();
    }
}
